export default "__VITE_ASSET__d39ca1be__"